// VicTech #710:转真人计数的共享状态(给分页标签、测试读)。不进 vuex,免得动核心 store。
import { reactive } from 'vue';

export const needHumanState = reactive({
  accountId: null,
  count: 0,
  ready: false,
});
